// --------------------------------------------------------------------------
// videoModal.js
// --------------------------------------------------------------------------
// Uses fancybox to create lightbox image gallery
// --------------------------------------------------------------------------

RN.videoModal = function() {

  'use strict';

  function init() {
    byBehaviour('video-modal').each(function(){

        if(this.href.indexOf('youtube') >= 0){
            this.href = this.href.replace(new RegExp("watch\\?v=", "i"), 'embed/')
        } else if(this.href.indexOf('vimeo') >= 0){
            this.href = this.href.replace('vimeo.com', 'player.vimeo.com/video')
        } 
    });
    byBehaviour('video-modal').fancybox({
        type: 'iframe',
        aspectRatio: true
    });
  }

  return {
    init: init
  };

}();